import slidesImpact from '@/data/discover/slides/slides-2'
import storiesImpact from '@/data/discover/stories/stories-2'

import slidesSuccess from '@/data/discover/slides/slides-3'
import storiesSuccess from '@/data/discover/stories/stories-3'

import slidesToBelong from '@/data/discover/slides/slides-4'
import storiesToBelong from '@/data/discover/stories/stories-4'

import slidesBestSelf from '@/data/discover/slides/slides-5'
import storiesBestSelf from '@/data/discover/stories/stories-5'

export const alteredSlideGroups = [
    {},
    {
        slides: slidesImpact,
        stories: storiesImpact,
    },
    {
        slides: slidesToBelong,
        stories: storiesToBelong,
    },
    {
        slides: slidesBestSelf,
        stories: storiesBestSelf,
    },
    {
        slides: slidesSuccess,
        stories: storiesSuccess,
    },
]